// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';

// 福岡歴史年表
const historyChronology = document.querySelector('[data-role="fukuoka-history-chronology"]');
if (historyChronology !== null) {
  // 初期表示
  let defaultTemplateId;
  const switchBtns = historyChronology.querySelectorAll('.history-chronology-nav__btn');
  const showArea = document.getElementById('history-chronology-contents');
  switchBtns.forEach((btn) => {
    if (btn.classList.contains('is-active')) {
      defaultTemplateId = btn.getAttribute('data-template');
    }
  });
  const defaultTemplate = document.getElementById(defaultTemplateId);
  const defaultTemplateClone = defaultTemplate.content.cloneNode(true);
  showArea.appendChild(defaultTemplateClone);

  // 要素切り替え
  const switchArea = document.querySelector('.history-chronology-nav');
  switchArea.addEventListener('click', (e) => {
    const eraSwitch = e.target;
    if (eraSwitch.hasAttribute('data-template')) {
      while (showArea.firstChild) {
        showArea.removeChild(showArea.firstChild);
      }
      let templateTarget;
      let activeTemplate = eraSwitch.getAttribute('data-template');
      const showTemplate = document.getElementById(activeTemplate);
      const showTemplateClone = showTemplate.content.cloneNode(true);

      // ボタン切り替え
      switchBtns.forEach((eraSwitchBtn) => {
        templateTarget = eraSwitchBtn.getAttribute('data-template');
        if (templateTarget === activeTemplate) {
          eraSwitchBtn.classList.add('is-active');
          eraSwitchBtn.ariaSelected = true;
        } else {
          eraSwitchBtn.classList.remove('is-active');
          eraSwitchBtn.ariaSelected = false;
        }
      });

      // 中身切り替え
      showArea.appendChild(showTemplateClone);
    }
  });
}